/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentSplitDto } from './PaymentSplitDto';
import {
    PaymentSplitDtoFromJSON,
    PaymentSplitDtoFromJSONTyped,
    PaymentSplitDtoToJSON,
    PaymentSplitDtoToJSONTyped,
} from './PaymentSplitDto';
import type { TerminalTipDistributionType } from './TerminalTipDistributionType';
import {
    TerminalTipDistributionTypeFromJSON,
    TerminalTipDistributionTypeFromJSONTyped,
    TerminalTipDistributionTypeToJSON,
    TerminalTipDistributionTypeToJSONTyped,
} from './TerminalTipDistributionType';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentChannel } from './PaymentChannel';
import {
    PaymentChannelFromJSON,
    PaymentChannelFromJSONTyped,
    PaymentChannelToJSON,
    PaymentChannelToJSONTyped,
} from './PaymentChannel';
import type { InitiatePaymentTestOptions } from './InitiatePaymentTestOptions';
import {
    InitiatePaymentTestOptionsFromJSON,
    InitiatePaymentTestOptionsFromJSONTyped,
    InitiatePaymentTestOptionsToJSON,
    InitiatePaymentTestOptionsToJSONTyped,
} from './InitiatePaymentTestOptions';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface InitiatePaymentRequest
 */
export interface InitiatePaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    amount: string;
    /**
     * 
     * @type {Currency}
     * @memberof InitiatePaymentRequest
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentRequest
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof InitiatePaymentRequest
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    paymentReference: string;
    /**
     * 
     * @type {Array<PaymentSplitDto>}
     * @memberof InitiatePaymentRequest
     */
    paymentSplits: Array<PaymentSplitDto>;
    /**
     * 
     * @type {boolean}
     * @memberof InitiatePaymentRequest
     */
    printReceipt: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InitiatePaymentRequest
     */
    sendNotification: boolean;
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentRequest
     */
    version: number;
    /**
     * 
     * @type {PaymentChannel}
     * @memberof InitiatePaymentRequest
     */
    channel?: PaymentChannel | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    failureReturnUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    guestName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    invoiceReference?: string | null;
    /**
     * 
     * @type {FavritApp}
     * @memberof InitiatePaymentRequest
     */
    paymentInitiatedByApp?: FavritApp | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    returnUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    roomNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    shopperLocale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    telephoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    terminalId?: string | null;
    /**
     * 
     * @type {TerminalTipDistributionType}
     * @memberof InitiatePaymentRequest
     */
    terminalTipDistributionType?: TerminalTipDistributionType | null;
    /**
     * 
     * @type {InitiatePaymentTestOptions}
     * @memberof InitiatePaymentRequest
     */
    testOptions?: InitiatePaymentTestOptions | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InitiatePaymentRequest
     */
    unintegratedFields?: { [key: string]: string; };
}



/**
 * Check if a given object implements the InitiatePaymentRequest interface.
 */
export function instanceOfInitiatePaymentRequest(value: object): value is InitiatePaymentRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentSplits' in value) || value['paymentSplits'] === undefined) return false;
    if (!('printReceipt' in value) || value['printReceipt'] === undefined) return false;
    if (!('sendNotification' in value) || value['sendNotification'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function InitiatePaymentRequestFromJSON(json: any): InitiatePaymentRequest {
    return InitiatePaymentRequestFromJSONTyped(json, false);
}

export function InitiatePaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentReference': json['paymentReference'],
        'paymentSplits': ((json['paymentSplits'] as Array<any>).map(PaymentSplitDtoFromJSON)),
        'printReceipt': json['printReceipt'],
        'sendNotification': json['sendNotification'],
        'version': json['version'],
        'channel': json['channel'] === undefined ? undefined : json['channel'] === null ? null : PaymentChannelFromJSON(json['channel']),
        'failureReturnUrl': json['failureReturnUrl'] === undefined ? undefined : json['failureReturnUrl'] === null ? null : json['failureReturnUrl'],
        'guestName': json['guestName'] === undefined ? undefined : json['guestName'] === null ? null : json['guestName'],
        'invoiceReference': json['invoiceReference'] === undefined ? undefined : json['invoiceReference'] === null ? null : json['invoiceReference'],
        'paymentInitiatedByApp': json['paymentInitiatedByApp'] === undefined ? undefined : json['paymentInitiatedByApp'] === null ? null : FavritAppFromJSON(json['paymentInitiatedByApp']),
        'returnUrl': json['returnUrl'] === undefined ? undefined : json['returnUrl'] === null ? null : json['returnUrl'],
        'roomNumber': json['roomNumber'] === undefined ? undefined : json['roomNumber'] === null ? null : json['roomNumber'],
        'shopperLocale': json['shopperLocale'] === undefined ? undefined : json['shopperLocale'] === null ? null : json['shopperLocale'],
        'telephoneNumber': json['telephoneNumber'] === undefined ? undefined : json['telephoneNumber'] === null ? null : json['telephoneNumber'],
        'terminalId': json['terminalId'] === undefined ? undefined : json['terminalId'] === null ? null : json['terminalId'],
        'terminalTipDistributionType': json['terminalTipDistributionType'] === undefined ? undefined : json['terminalTipDistributionType'] === null ? null : TerminalTipDistributionTypeFromJSON(json['terminalTipDistributionType']),
        'testOptions': json['testOptions'] === undefined ? undefined : json['testOptions'] === null ? null : InitiatePaymentTestOptionsFromJSON(json['testOptions']),
        'unintegratedFields': json['unintegratedFields'] == null ? undefined : json['unintegratedFields'],
    };
}

export function InitiatePaymentRequestToJSON(json: any): InitiatePaymentRequest {
    return InitiatePaymentRequestToJSONTyped(json, false);
}

export function InitiatePaymentRequestToJSONTyped(value?: InitiatePaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentReference': value['paymentReference'],
        'paymentSplits': ((value['paymentSplits'] as Array<any>).map(PaymentSplitDtoToJSON)),
        'printReceipt': value['printReceipt'],
        'sendNotification': value['sendNotification'],
        'version': value['version'],
        'channel': PaymentChannelToJSON(value['channel']),
        'failureReturnUrl': value['failureReturnUrl'],
        'guestName': value['guestName'],
        'invoiceReference': value['invoiceReference'],
        'paymentInitiatedByApp': FavritAppToJSON(value['paymentInitiatedByApp']),
        'returnUrl': value['returnUrl'],
        'roomNumber': value['roomNumber'],
        'shopperLocale': value['shopperLocale'],
        'telephoneNumber': value['telephoneNumber'],
        'terminalId': value['terminalId'],
        'terminalTipDistributionType': TerminalTipDistributionTypeToJSON(value['terminalTipDistributionType']),
        'testOptions': InitiatePaymentTestOptionsToJSON(value['testOptions']),
        'unintegratedFields': value['unintegratedFields'],
    };
}

